import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const TransactionViewModule = new Module({
  id: 'transaction-view',
  name: 'Transaction',
  path: 'transaction',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Transaction/View'))
  )
});

const TransactionModules = [TransactionViewModule];

export default new ModuleBundle('Transaction', TransactionModules);
